var _mask, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgIsraeliFlag(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 30,
    viewBox: "0 0 30 30",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _mask || (_mask = /*#__PURE__*/React.createElement("mask", {
    id: "mask0",
    "mask-type": "alpha",
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 30,
    height: 30
  }, /*#__PURE__*/React.createElement("rect", {
    width: 30,
    height: 30,
    rx: 4,
    fill: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 30,
    height: 30,
    fill: "white"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 30,
    height: 4,
    transform: "translate(0 3)",
    fill: "#014D87"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M4.91406 0.958865L5.5 0L6.08594 0.958865L7.33301 3H9.82812H11L10.3887 4L9.1665 6L10.3887 8L11 9H9.82812H7.33301L6.08594 11.0411L5.5 12L4.91406 11.0411L3.66699 9H1.17188H0L0.611328 8L1.8335 6L0.611328 4L0 3H1.17188H3.66699L4.91406 0.958865ZM3.05566 4H1.7832L2.41943 5.04115L3.05566 4ZM3.00537 6L4.22754 4H6.77246L7.99463 6L6.77246 8H4.22754L3.00537 6ZM2.41943 6.95885L1.7832 8H3.05566L2.41943 6.95885ZM4.83887 9L5.5 10.0823L6.16113 9H4.83887ZM7.94434 8H9.2168L8.58057 6.95885L7.94434 8ZM8.58057 5.04115L9.2168 4H7.94434L8.58057 5.04115ZM6.16113 3H4.83887L5.5 1.91773L6.16113 3Z",
    transform: "translate(9 9)",
    fill: "#014D87"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 30,
    height: 4,
    transform: "translate(0 23)",
    fill: "#014D87"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIsraeliFlag);
export default __webpack_public_path__ + "static/media/israeli-flag.39e1ce861e338384fa4124b90d1e05c5.svg";
export { ForwardRef as ReactComponent };